import UiTracking from '../tracking/ui-tracking';

export default class Turnstile {
	private siteKey: string;
	private errorMessage: HTMLElement;
	private challengeSucceeded: boolean = false;
	private isInteractiveChallenge: boolean = false;
	private turnstileWrapper: HTMLDivElement;

	public constructor(form: HTMLFormElement, siteKey: string) {
		this.siteKey = siteKey;

		const turnstileContainer: HTMLDivElement = form.querySelector('.turnstile-container');
		turnstileContainer.classList.add('is-visible');
		this.turnstileWrapper = turnstileContainer.querySelector('.cf-turnstile');
		this.errorMessage = turnstileContainer.querySelector('.turnstile-error');

		const renderTurnstile = () =>
			turnstile.render(`#${this.turnstileWrapper.id}`, {
				sitekey: this.siteKey,
				size: 'flexible',
				retry: 'never',
				theme: 'light',
				appearance: 'interaction-only',
				callback: this.turnstileSuccessCallback,
				'error-callback': this.turnstileErrorCallback,
				'before-interactive-callback': this.turnstileBeforeInteractionCallback,
				language: document.documentElement.lang.toLowerCase(),
			});

		if (typeof turnstile === 'undefined') {
			const script: HTMLScriptElement = document.createElement('script');
			script.src = `https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit`;
			script.defer = true;
			script.onload = renderTurnstile;
			script.onerror = this.scriptErrorCallback;
			document.body.appendChild(script);
		} else {
			renderTurnstile();
		}
	}

	private scriptErrorCallback = (): void => {
		this.challengeSucceeded = true;
		document.dispatchEvent(
			new CustomEvent('pegLogger-logJsError-WP', {
				detail: {
					message: 'Error loading turnstile script',
					origin: 'Caught_JsError_WP',
					stacktrace: 'Error loading turnstile script',
				},
			})
		);
	};

	public validate(): boolean {
		if (!this.challengeSucceeded && this.isInteractiveChallenge) {
			this.showError();
		} else {
			this.hideError();
		}

		return this.challengeSucceeded;
	}

	public enableUi(): void {
		if (this.isInteractiveChallenge) {
			this.turnstileWrapper.removeAttribute('inert');
			this.turnstileWrapper.setAttribute('aria-hidden', 'false');
		}
	}

	private turnstileBeforeInteractionCallback = (): void => {
		this.isInteractiveChallenge = true;
		this.turnstileWrapper.classList.add('is-interactive-challenge');
	};

	private turnstileSuccessCallback = (): void => {
		this.challengeSucceeded = true;
		this.hideError();
	};

	private turnstileErrorCallback = (error: string): void => {
		UiTracking.trackUIEvent(
			'registration-form',
			'turnstile-widget',
			'turnstile-error',
			error,
			this.siteKey
		);
	};

	private showError = (): void => {
		this.errorMessage.classList.add('is-visible');
		this.errorMessage.textContent = this.errorMessage.dataset.errorText;
	};

	public hideError = (): void => {
		this.errorMessage.textContent = '';
		this.errorMessage.classList.remove('is-visible');
	};
}
